import {
  ImportResultsColumn,
  StaticColumnMap,
} from '@components/bid_request/details/types';
import {
  PART_NUMBER_TEMPLATE_KEY_TO_COLUMN_NAME,
  STATIC_CUSTOM_COLUMN_KEYS,
} from '@components/bid_request/details/constants';

/**
 * Get custom matched headers
 * @param columns {ImportResultsColumn[]} - Array of ImportResultsColumn
 * @param staticColumnMap {StaticColumnMap} - static column map
 * @param isPriceUpdate {Boolean} - price-update event: preserve mapped static columns
 *   (Category and the SKU columns) as custom columns
 * Matched static columns are re-emitted as unmapped custom columns labeled by the
 * template column name (sheet_column_name := template_column_name), so the grid shows the
 * canonical column label rather than the buyer's original sheet header.
 *
 * The two part-number template columns ("Internal Part Number/SKU",
 * "Supplier Part Number/SKU") are re-emitted under the shorter canonical labels the server
 * seeds by default ("Internal Part Number", "Supplier Part Number") so a mapped upload lands
 * in the seeded default column name instead of creating a second "…/SKU"-named column.
 */
export const getCustomMatchedHeaders = (
  columns: ImportResultsColumn[],
  staticColumnMap: StaticColumnMap,
  isPriceUpdate = false
) => {
  return columns
    .map((column, index) => {
      if (
        isPriceUpdate &&
        column.template_column_key &&
        STATIC_CUSTOM_COLUMN_KEYS.includes(column.template_column_key)
      ) {
        const columnIndex = staticColumnMap[column.template_column_key]?.[0];
        if (columnIndex !== undefined) {
          return {
            index: columnIndex,
            is_unmapped: true,
            sheet_column_name:
              PART_NUMBER_TEMPLATE_KEY_TO_COLUMN_NAME[column.template_column_key] ??
              column.template_column_name,
            template_column_key: column.template_column_key,
          };
        }
      }

      if (column.is_unmapped || column.is_custom) {
        return { index, ...column };
      }

      return null;
    })
    .filter(col => col !== null);
};
